import { render, staticRenderFns } from "./GreOrder.vue?vue&type=template&id=72a903f8&scoped=true&"
import script from "./GreOrder.vue?vue&type=script&lang=js&"
export * from "./GreOrder.vue?vue&type=script&lang=js&"
import style0 from "./GreOrder.vue?vue&type=style&index=0&id=72a903f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a903f8",
  null
  
)

export default component.exports